// @flow
import { DEBUG_ENABLED } from 'app/packages/trace-logger/debugFlags';

type AppInitAnnotationLabel =
  | 'AppInitMainStart'
  | 'AppInitLocaleDataLoaded'
  | 'ReduxStoreInitialized'
  | 'ContextInitialized';

type AppInitAnnotation = {| timestamp: number, label: AppInitAnnotationLabel |};

// Track timing of events occurred before trace logger is initialized
const appInitAnnotations: Array<AppInitAnnotation> = [];

export const addAppInitAnnotation = (label: AppInitAnnotationLabel) => {
  appInitAnnotations.push({ timestamp: Date.now(), label });
  if (DEBUG_ENABLED && window.performance) {
    window.performance.mark(label);
    window.performance.measure(`\u23F0${label}`, 'navigationStart', label);
  }
};

export const getAppInitAnnotations = (): Array<AppInitAnnotation> => appInitAnnotations;
